import React, { Component } from "react"

import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import { CHOICE } from "../constants/status"

import { sound } from "../constants"

const timerProps = {
    isPlaying: true,
    size: 120,
    strokeWidth: 15
}

const CHOICE_MAX = 12 + 1
const GAME_MAX = 10 + 1

class Timer extends Component {
    constructor() {
        super()
        this.state = {
            show: true
        }
    }

    renderTime = (value) => {

        const { status } = this.props
        const max = status === CHOICE ? CHOICE_MAX : GAME_MAX

        const time = (max - value) | 0

        return (
            <div className="time-text">{time}</div>
        )
    }

    render = () => {

        const { status, currentTime, hide, innerTimeShow } = this.props

        const choice = status === CHOICE

        const max = choice ? CHOICE_MAX : GAME_MAX
        const colorsTime = [max * 0.7, max * 0.4, 0]

        if (currentTime) {
            return (
                <div className={`timer-block ${choice ? "timer-choice" : ""}`}>
                    {
                        innerTimeShow ?
                            <CountdownCircleTimer
                                {...timerProps}
                                colors={['#66CE05', '#F7B801', '#A30000']}
                                colorsTime={colorsTime}
                                duration={max}
                                key={0}
                                trailColor='rgba(0,0,0,0.2)'
                                initialRemainingTime={currentTime}
                                onComplete={() => hide()}
                            >
                                {({ elapsedTime, color }) => (
                                    <span style={{ color }}>
                                        {this.renderTime(elapsedTime)}
                                    </span>
                                )}
                            </CountdownCircleTimer>
                            : null
                    }


                </div>
            )
        }

        return null

    }

}

export default Timer